import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { RefundRequest } from 'app/_interfaces/opayo.interface';

@Injectable({
  providedIn: 'root',
})
export class OpayoService {
  constructor(private http: HttpClient) {}

  public getTransaction(transactionId) {
    return this.http.get(environment.paymentsApi + `v1/transactions/${transactionId}`).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  public refundTransaction(body: RefundRequest) {
    return this.http
      .post(environment.paymentsApi + `v1/transactions/refund`, body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // HANDLE DATA
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      headers: headers,
      body: body,
    };
    return data;
  }

  private handleError(error: any) {
    return Observable.throw(new HttpErrorResponse(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/opayo.service.ts